// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/main-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   GLOBAL RESET & SETUP
=============================== */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  scroll-padding-top: 90px;
}

html,
body,
#root {
  height: 100%;
  width: 100%;
}

/* ===============================
   PREMIUM BACKGROUND - DARKER FOR BETTER CONTRAST
=============================== */

body {
  background:
    linear-gradient(180deg,
      rgba(3, 5, 12, 0.98) 0%,
      rgba(4, 7, 18, 0.96) 30%,
      rgba(5, 8, 20, 0.95) 60%,
      rgba(4, 7, 18, 0.96) 90%,
      rgba(3, 5, 12, 0.98) 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  line-height: 1.6;
}

/* Dark overlay for better readability */
body::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(3, 5, 12, 0.4);
  z-index: -1;
  pointer-events: none;
}

/* ===============================
   TRANSPARENT SECTIONS
=============================== */

section,
div,
.container,
.container-fluid {
  background: transparent !important;
}

/* ===============================
   CUSTOM SCROLLBAR - GRADIENT
=============================== */

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: rgba(5, 7, 12, 0.8);
  border-left: 1px solid rgba(139, 92, 246, 0.2);
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #6366f1, #a855f7);
  border-radius: 10px;
  border: 2px solid rgba(5, 7, 12, 0.8);
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #7c3aed, #ec4899);
  box-shadow: 0 0 10px rgba(168, 85, 247, 0.5);
}

/* ===============================
   SELECTION COLORS
=============================== */

::selection {
  background: rgba(99, 102, 241, 0.4);
  color: #ffffff;
}

::-moz-selection {
  background: rgba(99, 102, 241, 0.4);
  color: #ffffff;
}

/* ===============================
   UTILITIES
=============================== */

.text-gradient {
  background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ===============================
   SMOOTH TRANSITIONS
=============================== */

a,
button {
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

/* ===============================
   FOCUS STATES
=============================== */

a:focus-visible,
button:focus-visible,
input:focus-visible,
textarea:focus-visible {
  outline: 3px solid rgba(99, 102, 241, 0.5);
  outline-offset: 3px;
}

/* ===============================
   IMPROVED TEXT VISIBILITY
=============================== */

h1, h2, h3, h4, h5, h6 {
  color: #ffffff;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

p {
  color: rgba(255, 255, 255, 0.85);
}

/* ===============================
   GLOBAL GLOW EFFECT
=============================== */

@keyframes globalPulse {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;iCAEiC;;AAEjC;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;;iCAEiC;;AAEjC;EACE;;;;;;;2CAO6B;;EAE7B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;;EAE5B,cAAc;EACd;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;AACtB;;AAEA;;iCAEiC;;AAEjC;;;;EAIE,kCAAkC;AACpC;;AAEA;;iCAEiC;;AAEjC;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;;iCAEiC;;AAEjC;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;iCAEiC;;AAEjC;EACE,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;iCAEiC;;AAEjC;;EAEE,kDAAkD;AACpD;;AAEA;;iCAEiC;;AAEjC;;;;EAIE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;iCAEiC;;AAEjC;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;iCAEiC;;AAEjC;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* ===============================\n   GLOBAL RESET & SETUP\n=============================== */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  scroll-padding-top: 90px;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  width: 100%;\n}\n\n/* ===============================\n   PREMIUM BACKGROUND - DARKER FOR BETTER CONTRAST\n=============================== */\n\nbody {\n  background:\n    linear-gradient(180deg,\n      rgba(3, 5, 12, 0.98) 0%,\n      rgba(4, 7, 18, 0.96) 30%,\n      rgba(5, 8, 20, 0.95) 60%,\n      rgba(4, 7, 18, 0.96) 90%,\n      rgba(3, 5, 12, 0.98) 100%),\n    url(\"./assets/main-bg.png\");\n\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n\n  color: #ffffff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n  line-height: 1.6;\n}\n\n/* Dark overlay for better readability */\nbody::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(3, 5, 12, 0.4);\n  z-index: -1;\n  pointer-events: none;\n}\n\n/* ===============================\n   TRANSPARENT SECTIONS\n=============================== */\n\nsection,\ndiv,\n.container,\n.container-fluid {\n  background: transparent !important;\n}\n\n/* ===============================\n   CUSTOM SCROLLBAR - GRADIENT\n=============================== */\n\n::-webkit-scrollbar {\n  width: 12px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(5, 7, 12, 0.8);\n  border-left: 1px solid rgba(139, 92, 246, 0.2);\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(135deg, #6366f1, #a855f7);\n  border-radius: 10px;\n  border: 2px solid rgba(5, 7, 12, 0.8);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(135deg, #7c3aed, #ec4899);\n  box-shadow: 0 0 10px rgba(168, 85, 247, 0.5);\n}\n\n/* ===============================\n   SELECTION COLORS\n=============================== */\n\n::selection {\n  background: rgba(99, 102, 241, 0.4);\n  color: #ffffff;\n}\n\n::-moz-selection {\n  background: rgba(99, 102, 241, 0.4);\n  color: #ffffff;\n}\n\n/* ===============================\n   UTILITIES\n=============================== */\n\n.text-gradient {\n  background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* ===============================\n   SMOOTH TRANSITIONS\n=============================== */\n\na,\nbutton {\n  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* ===============================\n   FOCUS STATES\n=============================== */\n\na:focus-visible,\nbutton:focus-visible,\ninput:focus-visible,\ntextarea:focus-visible {\n  outline: 3px solid rgba(99, 102, 241, 0.5);\n  outline-offset: 3px;\n}\n\n/* ===============================\n   IMPROVED TEXT VISIBILITY\n=============================== */\n\nh1, h2, h3, h4, h5, h6 {\n  color: #ffffff;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\np {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* ===============================\n   GLOBAL GLOW EFFECT\n=============================== */\n\n@keyframes globalPulse {\n  0%, 100% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
